import { IRespuestaUsuario, RespuestaUsuario } from "./RespuestaUsuario.DTO";
import { IRespuestaEncuestaEstadoDTO, RespuestaEncuestaEstadoDTO } from "./RespuestaEncuestaEstado.DTO";
import { Nilable } from "../shared/utils/Nullable";

export interface IRespuestaEncuesta {
    serie_id: number;
    answers_by_user: IRespuestaUsuario[];
    answers_state: IRespuestaEncuestaEstadoDTO[];
}

export class RespuestaEncuesta {
    public envioId = 0;
    public respuestasDeUsuarios: RespuestaUsuario[] = [];
    public estadoRespuestas: RespuestaEncuestaEstadoDTO[] = [];

    constructor(json: Nilable<Partial<IRespuestaEncuesta>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IRespuestaEncuesta>) {
        if (json.serie_id != null) {
            this.envioId = json.serie_id;
        }
        if (json.answers_by_user != null) {
            this.respuestasDeUsuarios = json.answers_by_user.map(respuestaUsuario =>
                new RespuestaUsuario(respuestaUsuario));
        }
        if (json.answers_state != null) {
            this.estadoRespuestas = json.answers_state.map(estadoRespuesta =>
                new RespuestaEncuestaEstadoDTO(estadoRespuesta));
        }
    }

    public toJSON(): IRespuestaEncuesta {
        return {
            serie_id: this.envioId,
            answers_by_user: this.respuestasDeUsuarios.map(respuestaUsuario => respuestaUsuario.toJSON()),
            answers_state: this.estadoRespuestas.map(estadoRespuesta => estadoRespuesta.toJSON())
        };
    }
}
